import ResumeCardEducation from './ResumeCardEducation'
import ResumeCardExperience from './ResumeCardExperience'
import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isNonEmptyString, isNumber, isUnknownObject } from '~/shared/utils/guards'
import { formatSalary } from '~/shared/utils/helpers'
import { toDateAndTime } from '~/shared/utils/date'
import { toCroppedImage } from '~/shared/utils/image'

const PHOTO_SIZE = { width: 200, height: 200 }

const toTime = (value: unknown): number => {
  const time = isNonEmptyString(value) ? Date.parse(value) : Number.NaN
  return Number.isNaN(time) ? 0 : time
}


export default class ResumeCard extends BaseModel {
  static override constructorName = 'ResumeCardModel'

  id: number = 0
  name: string = ''
  salary: number = 0
  'formatted_salary': string = ''
  photo: string = ''
  residence: string = ''
  'experience_beauty': string = ''
  'update_date': string = ''
  education: ResumeCardEducation = new ResumeCardEducation()
  experience: ResumeCardExperience[] = []
  'last_position': ResumeCardExperience = new ResumeCardExperience()

  constructor(data?: unknown) {
    super(data)

    if (!isUnknownObject(data)) {
      return
    }

    fillOwnProperties(this, data, [
      'name',
      'formatted_salary',
      'education',
      'experience',
      'last_position',
    ])

    this.name = Array.isArray(data.desired_position)
      ? data.desired_position
          .map(item => (isUnknownObject(item) ? item.desired_position : item))
          .filter(isNonEmptyString)
          .join(', ')
      : ''
    this.photo = toCroppedImage(data.photo, PHOTO_SIZE)
    this.education = new ResumeCardEducation(data.education)

    if (isNumber(this.salary) && this.salary > 0) {
      this.formatted_salary = formatSalary(this.salary.toString())
    }

    if (isNonEmptyString(data.update_date)) {
      this.update_date = toDateAndTime(data.update_date)
    }

    if (Array.isArray(data.experience)) {
      // Сортировка по сырым датам: модель форматирует start_date в «Март 2020»,
      const sorted = [...data.experience].sort(
        (a, b) =>
          toTime(isUnknownObject(b) ? b.start_date : null) -
          toTime(isUnknownObject(a) ? a.start_date : null)
      )

      this.experience = sorted.map(item => new ResumeCardExperience(item))
      this.last_position = this.experience[0] ?? new ResumeCardExperience()
    }
  }
}

registerModel(ResumeCard)
